import { graphql } from "relay-runtime"

export const chCreateRecommendedMedicationMutation = graphql`
  mutation chCreateRecommendedMedicationMutation($input: Ch_createRecommendedMedicationInput!, $connections: [ID!]!) {
    chCreateRecommendedMedication: ch_createRecommendedMedication(input: $input) {
      ch_RecommendedMedication @prependNode(connections: $connections, edgeTypeName: "ch_ProgressNoteEdge") {
        medication {
          ...chMedicationFragment @relay(mask: false)
        }
        id
        medicationId
        patientId
        progressNoteId
      }

      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
